export default class severidadesService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/severidades',
			"id": '/api/severidades/:id',
			"new": '/api/severidades',
			'delete': '/api/severidades/:id'
		};
	}

	getAll(){
		let url = this.baseUrl + this.routes.all;
		return this.http.get(url);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	update(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.put(url, data);
	}

	delete(objId){
		let idRoute = this.routes.delete.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.delete(url);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/severidadesService.js